export default __webpack_public_path__ + "static/media/icon_delete_2.4986b438.svg";